import {IconProps} from 'types/IconProps'

const AlertIconFill = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '16'}
      height={height || '16'}
      viewBox='0 0 14 14'
      fill={color || '#F45045'}
    >
      <path
        d='M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM6.5 4C6.5 3.86739 6.55268 3.74021 6.64645 3.64645C6.74022 3.55268 6.86739 3.5 7 3.5C7.13261 3.5 7.25979 3.55268 7.35356 3.64645C7.44732 3.74021 7.5 3.86739 7.5 4V7.5C7.5 7.63261 7.44732 7.75979 7.35356 7.85355C7.25979 7.94732 7.13261 8 7 8C6.86739 8 6.74022 7.94732 6.64645 7.85355C6.55268 7.75979 6.5 7.63261 6.5 7.5V4ZM7 10.5C6.85167 10.5 6.70666 10.456 6.58333 10.3736C6.45999 10.2912 6.36386 10.1741 6.30709 10.037C6.25033 9.89997 6.23548 9.74917 6.26441 9.60368C6.29335 9.4582 6.36478 9.32456 6.46967 9.21967C6.57456 9.11478 6.7082 9.04335 6.85368 9.01441C6.99917 8.98547 7.14997 9.00033 7.28701 9.05709C7.42406 9.11386 7.54119 9.20999 7.6236 9.33332C7.70602 9.45666 7.75 9.60166 7.75 9.75C7.75 9.94891 7.67098 10.1397 7.53033 10.2803C7.38968 10.421 7.19892 10.5 7 10.5Z'
        fill='#F45045'
      />
    </svg>
  )
}

export default AlertIconFill
